import { InvitationDetailScreen } from "@/features/staff/invitations";

export default function InvitationDetailPage() {
  return <InvitationDetailScreen />;
}
